import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { postCities, showCities, updateCities } from "../../../../MyApi/admin/cities";
import { toast } from "react-toastify";
import { getGovernorates } from "../../../../MyApi/admin/governorates";
import { getCountries } from "../../../../MyApi/admin/countries/countries";
import Select from "react-select";
import i18next from "i18next";
import LangSelectModal from "../../../UI/langselectmodal";
import SkeletonWrapper from "../../../UI/skeletonWrapper";

const AddCityModal = ({ show, toggle, onClose ,refetch ,modalMode, modalId}) => {
  const [formData, setFormData] = useState({
    name:"",  
    city: "",
    country: null,
    country_id: null,
    governorate: null,
    governorate_id: null,
  });     
  const [selectedLangCode ,setSelectedLangCode]=useState("")
   const currentLang = i18next.language;
  //show 
const {data :citiesData ,isLoading}=useQuery(["showCity", modalId, selectedLangCode],()=>showCities(modalId ,selectedLangCode),{
  enabled:!!modalId && modalMode ==="edit"
})




  const { data: countriesData ,isLoading :isCountriesLoading} = useQuery("getCountries", getCountries);
  const { data: governoratesData ,isLoading: isGovernoatesLoading} = useQuery(["getGovernorates" ,formData.country_id], ()=>getGovernorates( formData.country_id));

  const countries = countriesData?.data?.countries || [];
  const governorates = governoratesData?.data?.governorates || [];
  const city = citiesData?.data.city ||{}




  useEffect(() => {
    if (modalMode === "edit" ) {
   
      console.log("currentLang", currentLang);
      setSelectedLangCode(currentLang);
    }
  }, []);
  useEffect(()=>{
  if(city && modalMode ==="edit"){
    setFormData((prev)=>({
     ...prev,
       name:city?.name,  
    city: "",
 
    governorate:  city?.governorate,
    governorate_id: city?.governorate?.id,
    }))
  }
  },[city])

  const mutation = useMutation({
    mutationKey: ["postCities"],
    mutationFn: (formData) => postCities(formData),
    onSuccess: (data) => {
      toast.success(data.message || "تمت إضافة المدينة بنجاح");
      onClose("city","add");
      refetch()
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "حدث خطأ أثناء الإضافة");
    },
  });

  const mutationUpdate = useMutation({
    mutationKey: ["updateCities"],
    mutationFn: (postData) => updateCities(postData ,"",modalId),
    onSuccess: (data) => {
      toast.success(data.message || "تمت إضافة المدينة بنجاح");
      onClose("city","edit");
      refetch()
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "حدث خطأ أثناء الإضافة");
    },
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
 const handleLangChange =(e)=>{
  setSelectedLangCode(e.target.value)
 }

  const handleSelectChange = (name, option) => {
    setFormData((prev) => {
      if (name === "country")
        return { ...prev, country: option, country_id: option?.id || null };
      if (name === "governorate")
        return { ...prev, governorate: option, governorate_id: option?.id || null };
    
      return prev;
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

   if(modalMode ==="edit"){
    const updatedFormData = {
      ...formData,
      "_method": "PUT",
      lang: selectedLangCode,
    };

    mutationUpdate.mutate(updatedFormData);
   }else{

    mutation.mutate(formData);
   }

  };

  return (
    <Modal isOpen={show} toggle={toggle} centered dir="rtl" >
      <ModalHeader className="text-primary" toggle={toggle} closeButton>
        { modalMode ==="edit" ?"تعديل":"إضافة"}     مدينة جديدة
      </ModalHeader>

      <ModalBody>
        <p className="text-muted mb-3">أضف مدينة جديدة لدايم</p>
 
        <Form onSubmit={handleSubmit} className="add">
         {modalMode ==="edit" && <LangSelectModal handleChange={handleLangChange} selectedLangCode={selectedLangCode}/>}
         
          <FormGroup>
            <Label for="city">اسم المدينة</Label>
                <SkeletonWrapper isLoading={isLoading}>

            <Input
              id="name"
              name="name"
              placeholder="أدخل اسم المدينة"
              value={formData.name}
              onChange={handleChange}
              required
              />
              </SkeletonWrapper>
          </FormGroup>
       

      
        <div className="mb-3">
            <Label className="form-label">الدولة</Label>
            <SkeletonWrapper isLoading={isLoading}>

            <Select
              options={countries}
              value={formData.country}
              onChange={(option) => handleSelectChange("country", option)}
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.id}
              placeholder="اختر الدولة لفترة المحافظات"
              />
              </SkeletonWrapper>
          </div>
      

     
          <div className="mb-3">
            <Label className="form-label">المحافظة</Label>
             <SkeletonWrapper isLoading={isLoading}>

            <Select
            isDisabled={isGovernoatesLoading &&formData.country_id}
            options={governorates}
            value={formData.governorate}
            onChange={(option) => handleSelectChange("governorate", option)}
            getOptionLabel={(opt) => opt.name}
            isLoading={isLoading}
            getOptionValue={(opt) => opt.id}
            placeholder={isGovernoatesLoading && formData.country_id?  "جاري فلترة المحافظات": "اختر المحافظة"}
            />
            </SkeletonWrapper>
          </div>
      

    
      
        </Form>
      </ModalBody>

      <ModalFooter className="justify-content-start">
        <Button color="primary" onClick={handleSubmit} disabled={mutation.isLoading}>
          {mutation.isLoading ? "جارٍ الإضافة..." :  modalMode ==="edit"  ?" تعديل مدينة":"إضافة مدينة"}
        </Button>
        <button className="btn btn-white" onClick={() => onClose("city")}>
          إلغاء
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AddCityModal;
